import { Pipe, PipeTransform } from '@angular/core';
import { FilterOption, FilterSorting } from '../models';

@Pipe({ name: 'sort', standalone: true })
export class SortPipe implements PipeTransform {
  transform(filterOptions: FilterOption[], sorting: FilterSorting = 'alphabetic'): FilterOption[] {
    if (sorting === 'inherit') {
      return filterOptions;
    }

    return filterOptions.sort((a: FilterOption, b: FilterOption) => {
      return a.label?.toUpperCase().localeCompare(b.label?.toUpperCase());
    });
  }
}
